class GazdaboltReviewList extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const cards = Array.from(this.querySelectorAll('.gb-reviews__card'));
    const button = this.querySelector('.gb-reviews__load-more');
    const status = this.querySelector('.gb-reviews__status');
    if (!button || cards.length === 0) return;
    let shown = Math.min(3, cards.length);
    const update = () => {
      cards.forEach((card, index) => { card.hidden = index >= shown; });
      button.hidden = shown >= cards.length;
    };
    update();
    button.addEventListener('click', () => {
      const firstNewCard = cards[shown];
      shown = Math.min(shown + 3, cards.length, 15);
      update();
      if (status) status.textContent = status.dataset.template.replace('[count]', String(shown)).replace('[total]', String(cards.length));
      if (firstNewCard) {
        firstNewCard.tabIndex = -1;
        firstNewCard.focus({ preventScroll: true });
        firstNewCard.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
      }
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() {
    this.controller?.abort();
  }
}
if (!customElements.get('gazdabolt-review-list')) {
  customElements.define('gazdabolt-review-list', GazdaboltReviewList);
}
